module.exports = __webpack_public_path__ + "img/dataCard.804e10c2.png";